import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { API, graphqlOperation } from 'aws-amplify'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Form from 'antd/lib/form'
import Select from 'antd/lib/select'
import { showUserConfigurator, updateUser } from '../redux/app/actions'
import { capitalizeEachWord } from '../lib/stringOperations'
import Overlay from './Overlay'
import { trimD1 } from './Admin/Users/Details/API'
//import { YOUR_NEW_PHONE_NUMBER } from '../constants/text'

const Option = Select.Option

const styles = {
	container: {
		width: 500,
		padding: '1.64em'
	},
	formContainer: {
		width: '60%',
		margin: 'auto'
	},
	buttonContainer: {
		display: 'flex'
	},
	error: {
		display: 'block',
		textAlign: 'center',
		color: 'red'

	}
}

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 8 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 16 },
	},
}

const updateOccupant = `mutation updateOccupant($pk: ID!, $sk: String!, $version: Int!,  $input: updateOccupantInput) {
    updateOccupant(pk: $pk, sk: $sk, expectedVersion: $version, input: $input) {
        pk
        sk
        d1
        d2
        firstName
        lastName
        email
        lastLogin
        version
        primaryContact
        roles
        metaData {
            createdAt
        }
        phone {
            number
        }
        workPhone {
            number
            extension
        }
        extraFields {
            key
            value
        }
        version
    }
}`

const UserConfigurator = () => {

	const user = useSelector(state => state.app.user)
	const tenant = useSelector(state => state.app.tenant)
	const building = useSelector(state => state.app.building)

	const [errorMessage, setErrorMessage] = useState('')
	const [suite, setSuite] = useState('')
	const [floor, setFloor] = useState('')
	const [firstName, setFirstName] = useState(capitalizeEachWord(user.firstName))
	const [lastName, setLastName] = useState(capitalizeEachWord(user.lastName))
	const [loading, setLoading] = useState(false)
	const [showForm, setShowForm] = useState(false)

	useEffect(() => {
		if (user.d1) {
			let floor = user.d1.split('#')[5]
			let suite = user.d1.split('#')[6]

			if (!floor || (building.settings?.systemConfig.suites && tenant.suites && !suite)) {
				setShowForm(true)
			}
		}
	}, [user])


	if (!showForm) return null


	const validateFields = (floor, suite) => {
		if (suite) {
			return firstName.length > 0 && lastName.length > 0 && floor.length > 0 && suite.length > 0
		} else {
			return firstName.length > 0 && lastName.length > 0 && floor.length > 0
		}
	}

	const saveUser = async () => {
		let _floor = tenant.floors.length > 1 ? floor : tenant.floors[0]
		let _suite = building.settings?.systemConfig.suites && tenant.suites ? tenant.suites.length > 1 ? suite : tenant.suites[0] : null

		if (validateFields(_floor, _suite)) {
			setLoading(true)

			const _data = {
				pk: user.pk,
				sk: user.sk,
				version: user.version || 1,
				input: {
					firstName: firstName.toLowerCase(),
					lastName: lastName.toLowerCase(),
					d1: `${trimD1(user.d1, 5)}#${_floor}#${_suite}`,
				}
			}

			try {
				let response = await API.graphql(graphqlOperation(updateOccupant, _data))
				updateUser(response.data.updateOccupant)
				setShowForm(false)
			} catch (e) {
				console.log('error: ', e)
				throw Error(e)
			}
		} else {
			setErrorMessage('* Please fill out all required fields')
		}
	}

	return (
		<Overlay
			onClose={() => setErrorMessage('* Please fill out all required fields')}
			visible={showForm}
			headerText={'User Setup'}
			closebutton={false}
		>
			<div style={styles.container}>
				<span style={styles.error}>{errorMessage}</span>
				<div style={styles.formContainer}>
					<Form onSubmit={saveUser}>
						<Form.Item
							{...formItemLayout}
							label="First Name"
							required={true}
						>
							<Input name="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
						</Form.Item>
						<Form.Item
							{...formItemLayout}
							label="Last Name"
							required={true}
						>
							<Input name="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
						</Form.Item>
						<Form.Item
							{...formItemLayout}
							label="Floor"
							required={true}
						>
							{tenant.floors.length > 1 ? <Select placeholder={"Select Floor..."} allowClear onChange={(value) => setFloor(value)}>
								{tenant.floors.map((floor) => <Option key={floor}
									value={floor}>Floor {floor}</Option>)}
							</Select> : <span>{tenant.floors[0]}</span>}

						</Form.Item>
						{building.settings?.systemConfig.suites && tenant.suites &&
							<Form.Item
								{...formItemLayout}
								label="Suite"
								required={true}
							>
								{tenant.suites && tenant.suites.length > 1 ? <Select placeholder={"Select Suite..."} allowClear onChange={(value) => setSuite(value)}>
									{tenant.suites.map((suite) => <Option key={suite} value={suite}>Suite {suite}</Option>)}
								</Select> :
									<span>{tenant.suites ? tenant.suites[0] : "--"}</span>}
							</Form.Item>
						}
					</Form>
				</div>
				<div style={styles.buttonContainer}>
					<Button style={{ margin: 'auto', display: 'block' }} onClick={saveUser}
						type="primary">Update</Button>
				</div>
			</div>
		</Overlay>
	)
}


export default UserConfigurator